<template>
  <div class="seven">
    <h1 :class="$vuetify.breakpoint.xs ? 'text-h6' : ''">
      {{ $t(title) }}
    </h1>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null
    }
  }
};
</script>

<style>
.seven h1 {
  text-align: center;
  font-size: 30px;
  font-weight: 300;
  letter-spacing: 1px;

  display: grid;
  grid-template-columns: 1fr max-content 1fr;
  grid-template-rows: 27px 0;
  grid-gap: 20px;
  align-items: center;
}

.seven h1:after,
.seven h1:before {
  content: " ";
  display: block;
  border-bottom: 1px solid #5c6bc0;
  border-top: 1px solid #5c6bc0;
  height: 5px;
}
</style>
